import gql from 'graphql-tag'

import { MediaFieldsFragment } from '../media'

export { ProfileMediaFields as IProfileMedia } from './__generated__/ProfileMediaFields'

export const ProfileMediaFieldsFragment = gql`
  fragment ProfileMediaFields on ProfileMedia {
    index
    caption
    media {
      ...MediaFields
    }
  }

  ${MediaFieldsFragment}
`
